import './App.css';
import React, {Suspense} from 'react'
import {Route, Routes} from 'react-router-dom'
import {PrivateRoute} from "./components/PrivateRoute/PrivateRoute"
import Login from "./components/Login";
import lazyWithRetry from "./utils/lazyWithRetry";

// Lazy-load all route components except Login (most common entry point) [SEPAHELD-FRONTEND-PERF]
const MainApp = lazyWithRetry(() => import("./MainApp"));
const Register = lazyWithRetry(() => import("./components/Register"));
const ResetPassword = lazyWithRetry(() => import("./components/Register/ResetPassword"));
const SetNewPassword = lazyWithRetry(() => import("./components/Register/SetNewPassword"));
const Invitation = lazyWithRetry(() => import("./components/Register/Invitation"));
const ServiceDown = lazyWithRetry(() => import("./components/ServiceDown"));
const RedirectGoCardless = lazyWithRetry(() => import("./components/Redirect/RedirectGoCardless"));
const RedirectLexoffice = lazyWithRetry(() => import("./components/Redirect/RedirectLexoffice"));
const RedirectDirectErp = lazyWithRetry(() => import("./components/Redirect/RedirectDirectErp"));
const GoCardlessUnauthenticated = lazyWithRetry(() => import("./components/GoCardlessUnauthenticated"));
const ErpUnauthenticated = lazyWithRetry(() => import("./components/ErpUnauthenticated"));
const CancelFlowPage = lazyWithRetry(() => import("./components/CancelFlow/CancelFlowPage"));
const LoginService = lazyWithRetry(() => import("./components/Login/LoginService"));
const OAuthConsentPage = lazyWithRetry(() => import("./components/OAuthConsent/OAuthConsentPage"));
const PublicMandateApiDocsPage = lazyWithRetry(() => import("./components/PublicMandateApiDocs/PublicMandateApiDocsPage"));
const PublicEmailSubscriptionPage = lazyWithRetry(() => import("./components/EmailSubscriptionPreferences"));
const SupportFeedbackFooter = lazyWithRetry(() => import("./components/SupportFeedbackFooter/SupportFeedbackFooter"));

function App() {

  return (
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/api/connect/lexoffice/*"
                   element={<RedirectLexoffice/>}/>
            <Route path="/api/connect/goCardless/*"
                   element={<RedirectGoCardless/>}/>
            <Route path="/integrations/wisomeinbuero/callback"
                   element={<RedirectDirectErp erp="wisomeinbuero" providerName="WISO MeinBüro"/>}/>
            <Route path="/integrations/invoiz/callback"
                   element={<RedirectDirectErp erp="invoiz" providerName="invoiz"/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/service/login" element={<LoginService/>}/>
            <Route path="/register" element={<Register/>}/>
            <Route path="/reset-password" element={<ResetPassword/>}/>
            <Route path="/invitation" element={<Invitation/>}/>
            <Route path="/forgotten-password" element={<SetNewPassword/>}/>
            <Route path="/service-down" element={<ServiceDown/>}/>
            <Route path="/email-subscription" element={<PublicEmailSubscriptionPage/>}/>
            <Route path="/email-subscription/:customerId" element={<PublicEmailSubscriptionPage/>}/>
            <Route path="/GoCardlessUnauthenticated"
                   element={<GoCardlessUnauthenticated/>}/>
            <Route path="/erpUnauthenticated"
                   element={<ErpUnauthenticated/>}/>
            <Route
                path="/subscription/cancel"
                element={
                  <PrivateRoute>
                    <CancelFlowPage/>
                  </PrivateRoute>
                }
            />

            <Route
                path="/oauth/consent"
                element={
                  <PrivateRoute>
                    <OAuthConsentPage/>
                  </PrivateRoute>
                }
            />

            <Route
                path="/public-mandate-api-docs"
                element={
                  <PrivateRoute>
                    <PublicMandateApiDocsPage/>
                  </PrivateRoute>
                }
            />

            <Route
                path="/app/*"
                element={
                  <PrivateRoute>
                    <MainApp/>
                  </PrivateRoute>
                }
            />

            <Route path="*" element={
              <PrivateRoute>
                <MainApp/>
              </PrivateRoute>
            }/>
          </Routes>
          <SupportFeedbackFooter/>
        </Suspense>
      </div>
  );
}

export default App
